<template>
     <div class="centralizado bg-cubo">

<div class="cubo">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>

</div>
<div class="loading">
  <div class="">
    <h1>Cargando. . .</h1>
  </div>

</div>
</div>
</template>

<script>
export default {
    name: 'SolimanologSpinner',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style  scoped>

 .bg-cubo {
 
    margin:0;
    padding:0;
    background: #ffffff;
    color: rgb(0, 0, 0);
    min-height: 100vh;
}

.cubo, .loading {
    display: flex;
    justify-content: center;
    align-items: center;
}

.centralizado{
    padding-top:6%;
    width: 20%;
    height: 300px;
}

.cubo{
    height:60%;
    transform-style: preserve-3d;
    animation: rotar 8s linear infinite;
}

.cubo > span {
    position:absolute;
    width: 6em;
    height: 6em;
    border: 2px solid rgb(15, 15, 15);
    box-shadow: inset 10px 12px 50px 15px rgb(67, 195,255,.2), 0px 0px 40px 1px rgba(67,195,255,.15);
    border-radius: 4px;

}

.cubo > span:nth-child(1){transform: rotateY(90deg)translateZ(3em) ;
}

.cubo > span:nth-child(2){transform: rotateY(90deg)translateZ(-3em) ;
}

.cubo > span:nth-child(3){transform: rotateY(90deg)translateZ(-3em) ;
}

.cubo > span:nth-child(4){transform: rotateY(90deg)translateZ(3em) ;
}
.cubo > span:nth-child(5){transform: translateZ(-3em) ;
}
.cubo > span:nth-child(6){transform: translateZ(3em) ;
}

.loading{
    height:0%;
}

@keyframes rotar{
    0%{transform: rotateY(0deg)rotateX(0deg);}
    50%{transform: rotateY(360deg)rotateX(360deg);}
    100%{transform: rotateY(0deg)rotateX(0deg);}
}

</style>